import { createContext } from "react";

const ReporteContabilidadContext = createContext();

export default ReporteContabilidadContext;
